
import { ReactNode } from "react";

interface InvoiceHeaderProps {
  children?: ReactNode;
}

export function InvoiceHeader({ children }: InvoiceHeaderProps) {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div className="space-y-1">
        <h1 className="text-3xl font-bold tracking-tight">Invoices</h1>
        <p className="text-muted-foreground">
          Generate and manage your monthly invoices
        </p>
      </div>
      {children}
    </div>
  );
}
